module.exports = __webpack_public_path__ + "media/photo/Group 423@2x-8f20e204.jpg";